'use strict';
import ajax from '../../ajax';
import progress from '../../progress';
import tooltip from '../../tooltip';
import util from '../../util';
import validator from '../../validator';
import summarysection from '../../pages/summarysection';
import index from '../product/index';
import customModal from '../..//modal';
import cart from '../cart';
import newAddressForm from '../../addressForm/address-form';
import inputField from '../../addressForm/input-field';
import checkoutAddress from './address';
import googleAddressAutocomplete from './googleAddressAutocomplete';
import analytics from '../../analytics';
import account from './../account';
import royalMail from "../../royal-mail";
import chronopostPickup from "../../chronopost_pickup";
import mondialRelay from "../../mondial-relay";
import reinsuranceCheckout from "../reinsuranceCheckout";
import checkoutHeader from './checkout-header-accordion';
import { singleShippingDesign } from './billing';



var $cache, shippingMethods;

if ($(window).width() > 991 && $('#secondary').length && $('.checkout_page').length) {
    const primaryBillingLength = $('#primary .billing').length;
    const reinsuranceCheckoutMobileLength = $('.reinsurance-checkout-mobile').length;
    var stickySidebar = new StickySidebar('#secondary .right-side-checkout', {
        topSpacing: primaryBillingLength > 0 && reinsuranceCheckoutMobileLength === 0 ? -116 : primaryBillingLength > 0 && reinsuranceCheckoutMobileLength > 0 ? 11 : 116,
        bottomSpacing: reinsuranceCheckoutMobileLength ? -132 : 80,
        resizeSensor: true,
        innerWrapperSelector: '.sidebar__inner'
    });
}

function initCache() {
	const $formEle = $('form[id$="_shippingAddress"]');
	$cache = {
		addrForm: {
			address1: $formEle.find('input[name$="_address1"]'),
			address2: $formEle.find('input[name$="_address2"]'),
			countryCode: $formEle.find('select[id$="_country"]'),
			stateCode: $formEle.find('select[id$="_state"]'),
			postalCode: $formEle.find('input[name$="_postal"]'),
			city: $formEle.find('input[name$="_city"]')
		}
	};
}

//address modal close
function addressModalClose() {
    $('#modal-custom-placeholder').on("click", ".edit-add-address .cancel-button", handleCancelButtonClick);
}

function handleCancelButtonClick() {
    $(this).closest('.modal-overlay').remove();
    $('html').removeClass('modal-open');
    $('body').removeClass('body-fixed');
}

//Form Submission for create address modal
function addressCreateFromModal () {
    $('#EditAddressForm').on('click', '.add-edit-shipping-btn', function (e) {	
    	e.preventDefault();
    	e.stopPropagation();
    	const formAction = $('#EditAddressForm').attr('action');
    	const $form = $('form#EditAddressForm');
    	const postData = $form.serialize() + "&dwfrm_profile_address_create=dwfrm_profile_address_create=" + $( "body" ).hasClass( "checkout_page" );
    	$.ajax({
    		type: 'POST',
    		url: formAction,
    		data: postData,
    		success: function (response) {
    			if (response && response.success) {
    				location.reload();
    			} else {
    				console.error('Unexpected response structure:', response);
    				alert('An error occurred while processing your request.');
    			}
    		}
    	});
    });
}

$(window).on('load',function() { 
	stickySideBarInit();
})

//Form Submission of edit address Modal
function addressEditFromModal (addressid) {
	$('#EditAddressForm').on('click', '.add-edit-shipping-btn', function (e) {	
		e.preventDefault();
		e.stopPropagation();
		var formAction = $('#EditAddressForm').attr('action');
		var $form = $('form#EditAddressForm');
		var postData = $form.serialize() + "&dwfrm_profile_address_edit=dwfrm_profile_address_edit&addressid=" + addressid;
		$.ajax({
			type: 'POST',
			url: formAction,
			data: postData,
			success: function (response) {
				if(response.success){
					location.reload();
				}
			}
		});
	});
}

function initEvents() {
	//emea
	addressModalClose();
	$('.saved-addresses.select-shipping-address')
		// create address link
		.off().on("click", ".address-create", function(evt) {
			$('.ajax-loader').show();
			$.ajax({
				url: Urls.checkoutAddAddress,
				dataType: 'html',
				success: function(response)
				{
                    function handleAddressResponse(response) {
                      customModal.createCustomModal('edit-add-address new-add-address', '#modal-custom-placeholder');
                      $('.edit-add-address').find('.modal-body').html(response);
                      util.bodyPositionFixed('edit-add-address');
                      !$('.edit-add-address .focus-in .phonenumber').val() && $('.edit-add-address .phonenumber').closest('.focus-in').removeClass('focus-in');
                      $('.ajax-loader').hide();
                      addressModalClose();
                      googleAddressAutocomplete.init();
                    }

                    if(response.indexOf('header-wrapper') === -1) {
                      handleAddressResponse(response);
                    }
                    $( ".editaddress").find(".redesign-hidden" ).after( $( ".placecountry-editaddress" ) );
				}
			}).always(function(data) {
				checkoutAddress.init();
				googleAddressAutocomplete.init();
				$('select').selectmenu();
				$('.edit-add-address .modal-body').scrollBox();
				validator.initStateValidation();
				validator.initCountryChangeValidation();
				validator.initForm('form[id="EditAddressForm"]');
				newAddressForm.init();
				//prepopulate both Phone fields while editting
				newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());   
				$('.material-select .input-text.country').length && $(this).closest('.material-select .input-text.country').find('.icon_checkmark').remove();  
			});
			const createAutocompleteCall = util.debounce(() => {
				util.limitCharacters();
				addressCreateFromModal();
				if($('.checkout-shipping').length && $('.shipping-phonefield.postal-code .input-text.postal').val()) {
					$('.shipping-phonefield.postal-code .icon_checkmark').show();
				   }
				   $('.addressname .addressid').attr('type', 'hidden'); // Avoid to autocomplete address 1
				   validator.changeFieldValidation();
			}, 2500);
			createAutocompleteCall();
		})

		// edit address link
		.on("click", ".address-edit", function(evt) {
			const $this = $(this);
			const addressID = $this.data('addressId');

			$('.ajax-loader').show();
			$.ajax({
				url: Urls.checkoutEditAddress + encodeURIComponent(addressID),
				dataType: 'html',
				success: function(response)
				{
					getValidPostalCity(addressID,true,false);					
				}
			})
			.always(function() {
				inputField.setEditMaterialFields('.edit-add-address .material-input .input-text, .edit-add-address .material-input .input-textarea');
			});
			const editAutocompleteCall = util.debounce(() => {
				util.limitCharacters();
				$('.addressname .addressid').attr('type', 'hidden'); // Avoid to autocomplete address 1
				addressEditFromModal(addressID);
				$( ".editaddress").find(".redesign-hidden" ).after( $( ".placecountry-editaddress" ) );
				validator.changeFieldValidation();
			}, 2500);
			editAutocompleteCall();
		})

		// authenticated user address change
		.on('click', '.address-list .address-tile', function(evt) {
			const $this = $(this);
			if ($this.is('.selected, .default') || evt.target.nodeName == 'A') {
				return false;
			}

			$('.select-shipping-address').find('.address-list .address-tile').each(function() {
				const $this = $(this);
				$this.removeClass('selected');
				$this.removeClass('default');
			});

			$this.addClass('selected');

			const element = document.getElementById(evt.currentTarget.id);
			const addressID = element.dataset.addressId;

			// update address; on success update shipping method list
			$.get(Urls.updateAddressDetails, {
				addressID: addressID
			}, function(response) {
				getValidPostalCity(element.dataset.addressId,false,true);				
			}).always(function() {
				reinsuranceCheckout.reinsuranceCartOnDocumentReady();
				stickySideBarInit();
			});
		});

	// guest user address change
	var timer = null;
	$('.shipping-address-section').on('selectmenuchange change', 'input[name$="_shippingAddress_addressFields_address1"], input[name$="_shippingAddress_addressFields_address2"], select[name$="_shippingAddress_addressFields_country"], input[name$="_shippingAddress_addressFields_city"], input[name$="_shippingAddress_addressFields_postal"]', function() {
		if (!validateAddrForm()) {
			return;
		}
		if (timer) {
			window.clearTimeout(timer);
		}

		timer = window.setTimeout(function() {
			$.post(Urls.setShippingAddressDetails, $('form[id$="_singleshipping_shippingAddress"]').serialize(), function(result) {
				updateShippingMethodListHandler();
			});
		}, 200);
	});

	$('form[id$="_shippingAddress"]').on('blur', 'input[name$="_addressFields_firstName"], input[name$="_addressFields_lastName"], input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], select[name$="_addressFields_country"], input[name$="_addressFields_city"], input[name$="_addressFields_postal"], input[name$="_addressFields_phoneNumber"]', function() {	
		var validateErrorTimer = null;
		// to disable submit button when all fields are valid and no-shipping method error is visible
		if($(this).valid()) {
			if(validateErrorTimer) {
				window.clearTimeout(validateErrorTimer);
			}
			validateErrorTimer = window.setTimeout(function() {
				validateNoShippingMethodError();
			}, 100);
		}
	});
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
	const $summary = $('#secondary.summary');
	let couponError;

	if ($('.cart-coupon-code .error').length) {
		couponError = $('.cart-coupon-code .error').clone();
	}
	// indicate progress
	progress.show($summary);

	const url = Urls.summaryRefreshURL;

	// load the updated summary area
	$summary.load(url, function() {
		// hide edit shipping method link
		$summary.fadeIn('fast');

		// checkout checkout minicart on right side event handling
		addSummaryScrollbar();

		$summary.find('.checkout-mini-cart .minishipment .header a').hide();
		$summary.find('.order-totals-table .order-shipping .label a').hide();
		$('.cart-coupon-code').append(couponError);
		util.maximizeCheckoutSummary();
		analytics.gtmCouponApplied();

		// to disable submit button 
		// when 'No shipping method available' error message displayed
		validateNoShippingMethodError();
		reinsuranceCheckout.reinsuranceCartOnDocumentReady();
		stickySideBarInit();
		$('#secondary .product-item-container.sb-container').scrollBox();
	});

	const $summaryMobile = $('.minisummary-mobile');
	progress.show($summaryMobile);
	const mobileURL =Urls.summaryRefreshURLMobile;
	$summaryMobile.load(mobileURL, function() {
		$summaryMobile.fadeIn('fast');
		$summaryMobile.find('.checkout-mini-cart .minishipment .header a').hide();
		$summaryMobile.find('.order-totals-table .order-shipping .label a').hide();
	});
}

function getAddressFromTile() {
	var $selectedAddress = $(".address-tile.selected address");

	return {
		address1: $selectedAddress.data("address-one"),
		address2: $selectedAddress.data("address-two") || "",
		countryCode: $selectedAddress.data("country-code"),
		stateCode: $selectedAddress.data("state-code"),
		postalCode: $selectedAddress.data("postal-code"),
		city: $selectedAddress.data("city")
	};
}

function getAddressFromForm() {
	return {
		address1: $cache.addrForm.address1.val(),
		address2: $cache.addrForm.address2.val(),
		countryCode: $cache.addrForm.countryCode.val(),
		stateCode: $cache.addrForm.stateCode.val(),
		postalCode: $cache.addrForm.postalCode.val(),
		city: $cache.addrForm.city.val()
	};
}
/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
	const params = User.isCustomerAuthenticated && $('.address-tile.selected address').length > 0 ? getAddressFromTile() : getAddressFromForm();
	return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) { 
	// nothing entered
	if (!shippingMethodID) {
		return;
	}
	// attempt to set shipping method
	var url = getShippingMethodURL(Urls.selectShippingMethodsList, {
		shippingMethodID: shippingMethodID
	});
	ajax.getJson({
		url: url,
		callback: function(data) {
			updateSummary();
			stickySideBarInit();
			if (!data || !data.shippingMethodID) {
				window.alert('Couldn\'t select shipping method.');
				return false;
			}
			// display promotion in UI and update the summary section,
			// if some promotions were applied
			$('.shippingpromotions').empty();
		}
	});
}

/*
 * Valid Postal and City
 */

function getValidPostalCity(addressId,displModal,disableBut){	
	if(displModal){
		reintAddressModalDef(addressId);
	}else{
		updateShippingMethodListHandler();
	}
}

/**
 * re-init address modal with error
 */
function reintAddressModal(addressID){
		$('.ajax-loader').show();
		$.ajax({
			url: Urls.checkoutEditAddress + encodeURIComponent(addressID),
			dataType: 'html',
			success: function(response)
			{
				if(response.indexOf('header-wrapper') === -1) {
					customModal.createCustomModal('edit-add-address', '#modal-custom-placeholder');
					$('.edit-add-address').find('.modal-body').html(response);
					util.bodyPositionFixed('edit-add-address');
					$('.ajax-loader').hide();
					addressModalClose();
				}
			}
		}).always(function(data) {
			checkoutAddress.init();
			googleAddressAutocomplete.init();
			$('#EditAddressForm .postal').val('');
			$('#EditAddressForm .city').val('');
			$('select').selectmenu();
			validator.initStateValidation();
			validator.initCountryChangeValidation();
			validator.initForm('form[id="EditAddressForm"]');
			newAddressForm.init();
			//prepopulate both Phone fields while editting
			newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
			const $setDefaultCheckbox = $('input[id$="_setdefault"]');
			if ($setDefaultCheckbox.prop('checked')) {
				$setDefaultCheckbox.attr('disabled', 'true');
			}

			$('.edit-add-address .modal-body').scrollBox();
			
			$('.add-edit-shipping-btn').trigger('click');
		});
}

/**
 * re-init address modal with error
 */
function reintAddressModalDef(addressID){
		$('.ajax-loader').show();
		$.ajax({
			url: Urls.checkoutEditAddress + encodeURIComponent(addressID),
			dataType: 'html',
			success: function(response)
			{
				if(response.indexOf('header-wrapper') === -1) {
					customModal.createCustomModal('edit-add-address', '#modal-custom-placeholder');
					$('.edit-add-address').find('.modal-body').html(response);
					util.bodyPositionFixed('edit-add-address');
					$('.ajax-loader').hide();
					addressModalClose();
					googleAddressAutocomplete.init();
				}
			}
		}).always(function(data) {			
			$('select').selectmenu();
			checkoutAddress.init();
			googleAddressAutocomplete.init();
			validator.initStateValidation();
			validator.initCountryChangeValidation();
			validator.initForm('form[id="EditAddressForm"]');
			newAddressForm.init();
			//prepopulate both Phone fields while editting
			newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
			var setDefaultCheckbox = $('input[id$="_setdefault"]');
			if (setDefaultCheckbox.prop('checked')) {
				setDefaultCheckbox.attr('disabled', 'true');
			}

			$('.edit-add-address .modal-body').scrollBox();
		});
}

/**
 * @function
 * @description Handle selection of Mondial Relay shipping method
 * @param {jQuery} $element - The selected shipping method element
 */
function handleMondialRelaySelection($element) {
    // Enable other methods
    $(".royal-mail-method, .chronopost-method").removeAttr("disabled");

    // Activate edit button if store details exist
    if (!$(".store-details-section").is(':empty')) {
        $element.parent(".shipping-method").find(".store-address-edit").parents(".shipping-method").addClass("edit-btn-active");
    }

    // Handle confirmation
    $('.store-address-confirm').on("click", function (e) {
        mondialRelay.confirmationMondialRelayPopup();
        mondialRelay.closeMondialRelayPopup();
        $('#pickupStore_storeID').val($('#Target_Widget').val());
        var selectedStoreData = localStorage.getItem("selectedStoreData");
        if (selectedStoreData) {
            selectedStoreData = JSON.parse(selectedStoreData);
            var address = selectedStoreData.Adresse1;
            if (selectedStoreData.Adresse2) {
                address += ' ' + selectedStoreData.Adresse2;
            }
            $('#selectedStoreName').html(selectedStoreData.Nom);
            $('#pickupStore_storeAddress1').val(selectedStoreData.Nom);
            $('#pickupStore_storeAddress2').val(address);
            $('#pickupStore_storeAddressPostal').val(selectedStoreData.CP);
            $('#pickupStore_storeAddressCity').val(selectedStoreData.Ville);
            $('#pickupStore_storeAddressCountry').val(selectedStoreData.Pays);
            $('input[id$="_setdefault"]').prop('checked', true).attr('disabled', 'true');
            $('.store-details-section').html($('#TargetDisplayInfoPR_Widget').html()).addClass('filled');
            if (!$('.store-details-section').is(':empty')) {
                $('.store-details-section').parent().find('.store-address-edit').parents(".shipping-method").addClass("edit-btn-active");
            }
            $(".mondial-relay-method").attr("disabled", "disabled");
        }
    });

    // Handle popup close
    $('.mrelay-wrapper .mrelay-overlay, .mrelay-close').on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        mondialRelay.closeMondialRelayPopup();
        validateMondialRelayAddress();
    });

    // Bind edit button
    $element.parent().find('.store-address-edit').on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        mondialRelay.renderMondialRelayPopup();
        setTimeout(() => {
            if ($(".MR-Widget").length) {
                $('.PR-List-Item').on("click", function() {
                    if ($(this).hasClass('PR-Selected')) {
                        $('.zone_widget_confirm').removeClass('hide');
                    }
                });
            }
        }, 2000);
    });

    // Disable if already active, otherwise render popup
    if ($element.parent(".shipping-method").hasClass("edit-btn-active")) {
		let selectedStoreData = localStorage.getItem("selectedStoreData");
        if (selectedStoreData) {
            selectedStoreData = JSON.parse(selectedStoreData);
            let address = selectedStoreData.Adresse1;
            if (selectedStoreData.Adresse2) {
                address += ' ' + selectedStoreData.Adresse2;
            }
            $('#selectedStoreName').html(selectedStoreData.Nom);
            $('#pickupStore_storeAddress1').val(selectedStoreData.Nom);
            $('#pickupStore_storeAddress2').val(address);
            $('#pickupStore_storeAddressPostal').val(selectedStoreData.CP);
            $('#pickupStore_storeAddressCity').val(selectedStoreData.Ville);
            $('#pickupStore_storeAddressCountry').val(selectedStoreData.Pays);
        }
        $('#pickupStore_storeID').val($('#Target_Widget').val());
        $(".mondial-relay-method").attr("disabled", "disabled");
    } else {
        mondialRelay.renderMondialRelayPopup();
    }

    // Clear other data
    localStorage.removeItem('storedAddressData');
    localStorage.removeItem('royalMail-edit_' + $('royal-mail-method').val());
    $('.store-royalMail-details').removeClass('active');
	$('.chronopost-method').parent().removeClass('edit-btn-active');
}

/**
 * @function
 * @description Handle selection of Royal Mail shipping method
 * @param {jQuery} $element - The selected shipping method element
 */
function handleRoyalMailSelection($element) {
    const thisShipping = $element;

    // Activate edit button if details exist
    if (!$(".store-details-royalMail-section").is(':empty')) {
        $element.parent(".shipping-method").find(".store-address-edit").parents(".shipping-method").addClass("edit-btn-active");
    }

    // Enable all methods
    $(".mondial-relay-method, .royal-mail-method, .chronopost-method").removeAttr("disabled");

    // Clear or handle mondial data
    if (thisShipping.parent(".shipping-method").hasClass("edit-btn-active")) {
        localStorage.removeItem('selectedStoreData');
        $('.store-details-section').empty();
        $('.shipping-method').removeClass('edit-btn-active');
    } else {
        $('.store-details-section').empty();
    }

    // Close popup handlers
    function closePopupRoyal(thisShipping) {
        $('.royalMail-wrapper .royalMail-overlay, .royalMail-wrapper .widgfooter').on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            royalMail.closeRoyalMailPopup();
            validateRoyalMailAddress(thisShipping);
        });

        setTimeout(() => {
            $('.shipping-methods').on('click', '.royalMail-close', function (e) {
                e.stopPropagation();
                e.preventDefault();
                royalMail.closeRoyalMailPopup();
                validateRoyalMailAddress(thisShipping);
            });
        }, 1000);
    }

    closePopupRoyal(thisShipping);

    // Select button handler
    $('.shipping-methods').on('click', '.widget-select-button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        thisShipping.prop('checked', 'checked');
        royalMail.closeRoyalMailPopup();
    });

    // Render popup if not active
    if (!$element.parent('.shipping-method').find('.royalMail-wrapper').hasClass('active')) {
        if (thisShipping.parent().find(".store-details-royalMail-section").hasClass("filled")) {
            thisShipping.prop("disabled", "disabled");
        } else {
            const $royalMailWrapper = $('.royalMail-wrapper');
            const $royalMailOverlay = $('.royalMail-overlay');
            $royalMailWrapper.addClass('active');
            $royalMailOverlay.show();
            localCollectSelected(royalMail.renderRoyalMail($element));
        }
    }

    // Edit button handler
    const buttonEdit = thisShipping.parent().find('.store-royalMail-details .store-address-edit');
    buttonEdit.on('click', function(e) {
        e.stopPropagation();
        setTimeout(() => {
            localCollectSelected(royalMail.renderRoyalMail(thisShipping));
            const $royalMailWrapper = $('.royalMail-wrapper');
            const $royalMailOverlay = $('.royalMail-overlay');
            $royalMailWrapper.addClass('active');
            $royalMailOverlay.show();
        }, 500);
    });
}

/**
 * @function
 * @description Handle selection of Chronopost shipping method
 * @param {jQuery} $element - The selected shipping method element
 */
function handleChronopostSelection($element) {
    const thisShipping = $element;

    // Activate edit button if details exist
    if (!$(".store-details-chronopostpickup-section .postcode").is(':empty') && localStorage.getItem('storedAddressDataChronopost')) {
        $element.parent(".shipping-method").find(".store-address-edit").parents(".shipping-method").addClass("edit-btn-active");
		chronopostPickup.setPickupStoreValue($element);
    }

    // Handle filled state
    if (thisShipping.parent().find(".store-details-chronopostpickup-section").hasClass('filled')) {
        thisShipping.parent(".shipping-method").find(".store-address-edit").parents(".shipping-method").addClass("edit-btn-active");
        // Enable other methods
        $(".mondial-relay-method, .royal-mail-method").removeAttr("disabled");
    } else {
        // Open modal
        chronopostPickup.init();
    }

    // Edit button handler
    thisShipping.parent().find('.store-address-edit').off('click.chronoEdit').on('click.chronoEdit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $chronopostContainer = $('#chronopost-pickup-container');
        if ($chronopostContainer.find('.modal').length) {
            $('html').addClass('modal-open');
            $chronopostContainer.removeClass('hide');
        } else {
            chronopostPickup.init();
        }
    });
}

/**
 * @function
 * @description Handle selection of default/other shipping methods
 */
function handleDefaultSelection() {
    // Enable all methods
    $(".mondial-relay-method, .royal-mail-method, .chronopost-method").removeAttr("disabled");
}

/**
 * @function
 * @description Initialize shipping methods on page load
 * @param {jQuery} $shippingMethodList - The shipping method list container
 */
function initializeShippingMethodsOnLoad($shippingMethodList) {
    // Select first method if none selected
    if ($shippingMethodList.find('input:checked').length === 0) {
        $shippingMethodList.find('input:first').prop('checked', 'checked');
        const thisShipping = $shippingMethodList.find('.shipping-method-input:checked');
        const shippingID = $shippingMethodList.find('.shipping-method-input:checked').attr('value');
        const $storeDetailsSection = $('.store-details-section');
        let old_storedAddressData = JSON.parse(localStorage.getItem('storedAddressData'));
        if (localStorage.getItem('storedAddressData') != null && old_storedAddressData[shippingID]) {
            royalMail.updateRoyalMailShippingAddress(thisShipping);
            royalMail.setPickupStoreValue(thisShipping);
            $storeDetailsSection.empty();
        } else if (!$storeDetailsSection.is(':empty')) {
            $storeDetailsSection.parent().find('.store-address-edit').parents(".shipping-method").addClass("edit-btn-active");
            $storeDetailsSection.addClass('filled');
        }
        
    } else {
        const thisShipping = $shippingMethodList.find('input:checked');
        royalMail.updateRoyalMailShippingAddress(thisShipping);
        thisShipping.parent().find('.store-details-section').empty();

        // Edit button
        const buttonEdit = thisShipping.parent().find('.store-royalMail-details .store-address-edit');
        buttonEdit.on('click', function(e) {
            e.stopPropagation();
            setTimeout(() => {
                localCollectSelected(royalMail.renderRoyalMail(thisShipping));
                $('.royalMail-wrapper').addClass('active');
                $('.royalMail-overlay').show();
            }, 500);
        });

        // Chronopost
        if ($('.chronopost-method').length) {
            chronopostPickup.setPickupStoreValue(thisShipping);
            chronopostPickup.updateChronopostShippingAddress(thisShipping);
        }
    }

	if ($shippingMethodList.find('.input-radio:checked').hasClass('mondial-relay-method') ||
        $("input:radio.shipping-method-input:checked").hasClass('mondial-relay-method')) {

        if ($('.store-details-section').length > 0 && localStorage.getItem("storeDetailsSection")) {
            $(".store-details-section").html(localStorage.getItem("storeDetailsSection"));
            $('.store-address-edit, .address-pin-icon, .store-details-wrapper').removeClass('hide');
            $(".store-address-edit").addClass("edit-btn-active");

            let selectedStoreData = localStorage.getItem("selectedStoreData");
            if (selectedStoreData) {
                selectedStoreData = JSON.parse(selectedStoreData);
                let address = selectedStoreData.Adresse1;
                if (selectedStoreData.Adresse2) {
                    address += ' ' + selectedStoreData.Adresse2;
                }
                $('#pickupStore_storeID').val(selectedStoreData.Pays + "-" + selectedStoreData.ID);
                $('#pickupStore_storeAddress1').val(selectedStoreData.Nom);
                $('#pickupStore_storeAddress2').val(address);
                $('#pickupStore_storeAddressPostal').val(selectedStoreData.CP);
                $('#pickupStore_storeAddressCity').val(selectedStoreData.Ville);
                $('#pickupStore_storeAddressCountry').val(selectedStoreData.Pays);
            }
        }
    }

    // Handle Chronopost edit button activation
    if (localStorage.getItem("storedAddressDataChronopost") && !$('.store-details-chronopostpickup-section .postcode').is(':empty')) {
        $(".chronopost-method").parents(".shipping-method").addClass("edit-btn-active");
    }

    // Tooltip handler
    $('[class$="_MONDIAL_V"]').find(".tooltip").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
    });

    // Widget confirm visibility
    if ($('.PR-List-Item').hasClass('PR-Selected')) {
        $('.zone_widget_confirm').removeClass('hide');
    }
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodListHandler() {
	const $shippingMethodList = $('#shipping-method-list');
	if (!$shippingMethodList || $shippingMethodList.length === 0) {
		return ;
	}
	var url = getShippingMethodURL(Urls.shippingMethodsJSON);
	ajax.getJson({
		url: url,
		callback: function(data) {
			if (!data) {
				window.alert('Couldn\'t get list of applicable shipping methods.');
				return false;
			}

			// We need to update the UI.  The list has changed.
			// Cache the array of returned shipping methods.
			shippingMethods = data;
			// indicate progress
			progress.show($shippingMethodList);

			// load the shipping method form
			
			var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
			$shippingMethodList.load(smlUrl, function() {
				$shippingMethodList.fadeIn('fast');
				// rebind the radio buttons onclick function to a handler.
				$shippingMethodList.find('[name$="_shippingMethodID"]').click(function(e) {
					var $this = $(this);

					if ($this.hasClass('mondial-relay-method')) {
						handleMondialRelaySelection($this);
					} else if ($this.hasClass('royal-mail-method')) {
						handleRoyalMailSelection($this);
					} else if ($this.hasClass('chronopost-method')) {
						handleChronopostSelection($this);
					} else {
						handleDefaultSelection();
					}

					selectShippingMethod($this.val());
					royalMail.setPickupStoreValue($this);
				});

				// update the summary
				updateSummary();
				stickySideBarInit();
				progress.hide();
				tooltip.init();

				// Initialize shipping methods on load
				initializeShippingMethodsOnLoad($shippingMethodList);
			});
		}
	});
}

function validateAddrForm() {
	var addr = getAddressFromForm();
	return addr.address1 && addr.city && addr.postalCode && addr.countryCode;
}

function checkoutReinsurancePopup(dataContent) {
	$('#main').on('click', 'a.cart-reinsuance-modal', function (e) { // Old functionality not in use
		e.preventDefault();
		e.stopImmediatePropagation();
		var $this = $(this);
		analytics.reinsuranceElements($this.attr('id'));	
		
		$.ajax({
			url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
			method: 'GET'
		})
		.done(function (response) { 
			if (response) {
				customModal.createCustomModal('checkout-reinsurance-popup', '#modal-custom-placeholder');
				$('.checkout-reinsurance-popup').find('.modal-body').html(response);
				if($(window).width() > 768) {
					$('.checkout-reinsurance-popup').find('.modal-body').scrollBox();
					$(window).trigger("resize.scrollBox");
				}
			}
		});
	});
}

function validateNoShippingMethodError() {
	const $shippingMethodList = $('#shipping-method-list'),
		$shippingForm = $shippingMethodList.length && $shippingMethodList.closest('form[id$="_shippingAddress"]'),
		$invalidMethodError = $shippingMethodList.find('.no-shipping-methods'),
		$invalidFormError = $shippingForm.find("div.error-placement");

	if ($invalidMethodError.length && $invalidFormError.length) {
		$shippingForm.find('button[id$="_shippingAddress_save"]').attr('disabled', 'disabled');
	} else if($invalidMethodError.length && $invalidFormError.length === 0) {
		$shippingForm.find('button[id$="_shippingAddress_save"]').attr('disabled', 'disabled');		
	} else {
		$shippingForm.find('button[id$="_shippingAddress_save"]').removeAttr('disabled');
	}
	reinsuranceCheckout.reinsuranceCartOnDocumentReady();
	stickySideBarInit();
}

/**
 * Validate mondial relay address on click of submit button.
 */
function validateMondialRelayAddress() {
        if($("input:radio.shipping-method-input:checked").hasClass('mondial-relay-method') && $('.store-details-section').is(':empty')) {
        	const $shippingMethodList = $('#shipping-method-list');
        	progress.show($shippingMethodList);
        	$('input:radio.shipping-method-input').each(function() {
				if(!$(this).hasClass('mondial-relay-method')) {
					$(this).trigger('click');
					return false; // break loop
				}
    		});
        	progress.hide();            
        }
}

/**
 * Validate Royal Mail address on click of submit button.
 */
function validateRoyalMailAddress(thisShipping) {
        if($("input:radio.shipping-method-input:checked").hasClass('royal-mail-method') && thisShipping.parent().find('.store-details-royalMail-section .address-line1').is(':empty')) {
			const $shippingMethodList = $('#shipping-method-list');
			progress.show($shippingMethodList);
        	$('input:radio.shipping-method-input').each(function() {
				if(!$(this).hasClass('royal-mail-method')) {
					$(this).trigger('click');
					return false; // break loop
				}
    		});
        	progress.hide();            
        }
}

function savedAddressViewShipping () {
	const $savedAddressShipping = $('.saved-addresses.select-shipping-address .address-tile');
	if ($savedAddressShipping.length > 3) {
        $('.billing-address-section').before("<div class='shipping-address-show-more'>" + Resources.SEE_MORE_CARDS + "</div>");

        const $seeMore = $('.shipping-address-show-more');

        $seeMore.on('click', function () {
			if ($seeMore.text() !== Resources.SEE_LESS_CARDS) {
				$seeMore.text(Resources.SEE_LESS_CARDS);
				$seeMore.addClass('is-show');
				stickySidebar.destroy();
			} else {
				$seeMore.text(Resources.SEE_MORE_CARDS);
				$seeMore.removeClass('is-show');
			}

			$savedAddressShipping.toggle();
			const primaryBillingLength = $('#primary .billing').length;
			const reinsuranceCheckoutMobileLength = $('.reinsurance-checkout-mobile').length;
			if ($(window).width() > 991 && $('.checkout_page').length) {
				var stickySidebarNew = new StickySidebar('#secondary .right-side-checkout', {
					resizeSensor: true,
					topSpacing:  primaryBillingLength > 0 && reinsuranceCheckoutMobileLength === 0 ? -116 : primaryBillingLength > 0 && reinsuranceCheckoutMobileLength > 0 ? 11 : 116,
					bottomSpacing: reinsuranceCheckoutMobileLength ? -132 : 80,
					innerWrapperSelector: '.sidebar__inner'
				});
			}
        });
      }
}

function stickySideBarInit() {
    const $secondary = $('#secondary');
    const $checkoutRedesign = $('.checkout_page');
    
    if ($(window).width() > 991 && typeof pageInfo !== 'undefined' && pageInfo.pageSubCategory == 'Shipping' && $checkoutRedesign.length && $secondary.length) {
        const primaryBillingLength = $('#primary .billing').length;
        const reinsuranceCheckoutMobileLength = $('.reinsurance-checkout-mobile').length;
        
        var stickySidebar = new StickySidebar('#secondary .right-side-checkout', {
            topSpacing: (primaryBillingLength > 0 && reinsuranceCheckoutMobileLength === 0) ? -116 : (primaryBillingLength > 0 && reinsuranceCheckoutMobileLength) > 0 ? 11 : 116,
            bottomSpacing:  reinsuranceCheckoutMobileLength ? -132 : 80,
            resizeSensor: true,
            innerWrapperSelector: '.sidebar__inner'
        });
    }
}

function billingSectionErrorMessage () {
	$(window).on('load', function () {
		if(!$('.sameasbilling').is(':checked') && $('.select-billing-address .error-placement').length > 1) {
			$('.select-billing-address').find('.error-placement').parent().find('input').blur();
			stickySideBarInit()
		}
	})
}
function getShippingPhoneNumWithCode() {
	if($('#dwfrm_singleshipping_shippingAddress_addressFields_areaCode').length === 0 && $('#dwfrm_singleshipping_shippingAddress_addressFields_phoneNumber').length === 0) { 
		return; 
	}
	$('#modal-custom-placeholder, .checkout-shipping-content').on('focusout','input[class~="phonenumber"]', function() {
		const customFoneNumber = $('#dwfrm_singleshipping_shippingAddress_addressFields_phoneNumber').val();
		const selectedCountryCode = $('#dwfrm_singleshipping_shippingAddress_addressFields_country').val();
		const custFoneNumb = util.getFormattedPhoneNumber(customFoneNumber,selectedCountryCode);
		$('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val(custFoneNumb);		
	});
}

// Function to handle address tile selection
function handleAddressTileSelection() {
    $('.checkout-main-wrapper').find('.select-shipping-address div.address-list div.address-tile').each(function() {
        const $this = $(this);
        if ($this.hasClass('default') || $this.hasClass('selected') || $this.hasClass('address-default')) {
            $this.removeClass('selected default');
            $this.trigger('click');
        }
    });
}

// Function to initialize national ID validation
function initNationalIdValidation() {
    $('.nationalIDType select, .nationalIDType .ui-selectmenu-button').one('focus', function() {
        $(this).on("blur", function(e) {
            validator.initDocIdValidation();
        });
    });
}

// Function to handle shipping address save
function handleShippingAddressSave() {
    $('#dwfrm_singleshipping_shippingAddress button#dwfrm_singleshipping_shippingAddress_save').on('click', function() {
        validator.initDocIdValidation();
        stickySideBarInit();
    });
}

/**
 * Loads the reinsurance cart on the checkout page.
 * This function triggers the reinsurance cart loading process
 * by calling the reinsuranceCartOnLoad method from the reinsuranceCheckout module.
 */

function loadReinsuranceCart() {
	reinsuranceCheckout.reinsuranceCartOnLoad();
}

/**
 * Initializes the sticky sidebar functionality on the checkout page.
 * This function calls the stickySideBarInit method to set up and enable
 * the sticky sidebar behavior, keeping the sidebar fixed as the user scrolls.
 */

function initializeStickySidebar() {
	stickySideBarInit();
}

/**
 * Initializes the login container by adding a class to the input fields
 * if they are not empty. This is done to display the input field labels
 * above the input fields if they contain a value.
 * @memberof checkout
 */
function initializeLoginContainer() {
	const $loginInput = $('.checkout-login-container .input-text');
	if($loginInput.val() !== '') {
		$loginInput.closest('.material-input').addClass('focus-in');
	}
}

/**
 * Initializes the shipping address section by adding a class to the input fields
 * if they are not empty. This is done to display the input field labels above the
 * input fields if they contain a value. Also, moves the country field to the top.
 * @memberof shipping
 */
function initializeShippingSection() {
	const shippingSectionInputField = ".shipping-address-section .material-input .input-text";
	$(shippingSectionInputField).length && $(shippingSectionInputField).each(function(){
		if($(this).val() !== '' && !$(this).hasClass('areaCode')) {
			$(this).closest('.material-input').addClass('focus-in');
		}
	});
	const $phoneNumberError = $('.hide-country-field .phonenumber.error');
	const $phoneErrorPlacement = $('.hide-country-field .phone .error-placement');
	if($phoneNumberError.length && !$phoneErrorPlacement.length){
		$phoneNumberError.removeClass('error')
	}
	$(".shipping-address-section").find(".addressname").before($(".placecountry-first"));
}

function characterLimitEvents() {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

	$('body')
		.on('keydown', '[data-character-limit]', function (e) {
			var text = $(this).val(),
				charsLimit = $(this).data('character-limit'),
				charsUsed = text.length;

			if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
				e.preventDefault();
			}
		})
		.on('change keyup mouseup', '[data-character-limit]', function () {
			    var text = $(this).val(),
				charsLimit = $(this).data('character-limit'),
				charsUsed = text.length,
				charsRemain = charsLimit - charsUsed;

			if (charsRemain < 0) {
				$(this).val(text.slice(0, charsRemain));
				charsRemain = 0;
			}

			if (charsUsed <= charsLimit) {
				$(this).closest('.field-wrapper').find('.char-remain-count').html(charsRemain);
				$(this).closest('.field-wrapper').find('.char-used-count').html(charsUsed);
			}
		});
}

/**
 * @function
 * @description Intercepts coupon apply button click on shipping page,
 * submits via AJAX with format=ajax (mirrors cart's promoCodeBehaviour pattern),
 * then swaps in the fresh coupon block and refreshes the summary.
 */
function initCouponBehaviour() {

	// Ensure live region exists
	if ($('#coupon-live-region').length === 0) {
		$('body').append('<div id="coupon-live-region" aria-live="polite" role="status" class="visually-hidden"></div>');
	}

	// Enable or disable coupon form button
	function enableDisableButtonBasedOnCoupon() {
		const $btn = $('#add-coupon');
		if ($('input[name$="couponCode"]').val() == "") {
			$btn.prop('disabled', true);
		} else {
			$btn.prop('disabled', false);
		}
	}

	$('input[name$="_cart_couponCode"]').on('keyup', function () {
		enableDisableButtonBasedOnCoupon();
		hideCouponError();
	});

	$('input[name$="_cart_couponCode"]').on('paste cut', function () {
		setTimeout(() => {
			enableDisableButtonBasedOnCoupon();
		}, 500);
	});

	function hideCouponError() {
		$('body').on('keyup change', '.order-totals-table .cart-coupon-code input', function () {
			const error_msg = $('.cart-coupon-code').find('.error');
			if (error_msg.length) {
				$(error_msg)
					.hide()
					.removeAttr('role aria-live'); // clean up accessibility attrs

				$('#coupon-live-region').text('');
			}
		});
	}

	$('body')
		.on('click', 'button[name$="addCoupon"], button[name$="deleteCoupon"]', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();

			const $button = $(this);
			const $form = $button.closest('form');
			const actionType = $button.attr('name').includes('deleteCoupon') ? 'removed' : 'applied';
			const couponCodeText = $button.closest('.coupon-applied').find('.coupon-text').attr('data-name');
			const messageApplied = $('.coupon-info-text').attr('data-message-applied');
			const messageRemoved = $('.coupon-info-text').attr('data-message-removed');
			const $liveRegionContainer = $('#coupon-live-region');

			// Announce action immediately to screen readers before AJAX call
			// Avoid announcing an undefined coupon code — fall back to the generic message.
			let actionAnnouncement = '';
			if (couponCodeText) {
				actionAnnouncement = actionType === 'removed' && `${couponCodeText} ${messageRemoved}`;
			} else {
				actionAnnouncement = actionType === 'removed' ? messageRemoved : '';
			}
			$liveRegionContainer.text(actionAnnouncement);

			const postData =
				$form.serialize() +
				'&' +
				$button.attr('name') +
				'=' +
				($button.val() || $button.attr('name')) +
				'&format=ajax';

			$.ajax({
				type: 'POST',
				url: Urls.addPromoOnShipping,
				data: postData,
				success: function (response) {
					const $newCouponBlock = $(response).find('.cart-coupon-code');

					if ($newCouponBlock.length) {
						$('.cart-coupon-code').replaceWith($newCouponBlock);

						const couponCode = $newCouponBlock.find('.coupon-text').last().attr('data-name');

						// Announce action for applied coupon, avoid 'undefined'
						let finalAnnouncement = '';
						if (couponCode) {
							finalAnnouncement = actionType === 'applied' ? `${couponCode} ${messageApplied}` : '';
						}

						$liveRegionContainer.text(finalAnnouncement);

						// Handle error messages (if present)
						const $error = $newCouponBlock.find('.error');
						if ($error.length) {
							$error
								.attr('role', 'alert')
								.attr('aria-live', 'assertive');

							$liveRegionContainer.text($error.text().trim());
						}
					}

					updateSummary();
				},
				error: function () {
					// Announce failure clearly
					$('#coupon-live-region').text('Error applying coupon. Please try again.');
				},
				complete: function () {
					// Announce update
					setTimeout(() => {
						if (actionType === 'applied') {
							$('.cart-coupon-code').find('.removebutton').focus();
						} else {
							$('.cart-coupon-code').find('input[name$="couponCode"]').focus();
						}
					}, 2000);

				}
			});
		})
		.on('keydown', '.cart-coupon-code input', function (e) {
			if (e.which === 13) {
				e.preventDefault();
				$('#add-coupon').trigger('click');
			}
		});
}

/**
 * Initializes the checkout shipping module.
 * 
 * This function sets up various components and validations required for the
 * shipping section of the checkout process. It handles event binding, form
 * validation, and UI adjustments based on the redesign flag and user authentication status.
 */
export const updateShippingMethodList = updateShippingMethodListHandler;

export default {
	init : function() {
	initCache();
	initEvents();
	summarysection.init();
	initCouponBehaviour();
	//addressVerificationSvc.init();
	validator.initCountryChangeValidation();
	googleAddressAutocomplete.init();
	validator.initStateValidation();
	if (window.User.isCustomerAuthenticated == false) {
		$('.checkout-shipping').find('.set-default-cb').hide();
	}

	validator.initForm('form[name$="shippingAddress_save"]');
	updateShippingMethodListHandler();
	checkoutReinsurancePopup();
    handleAddressTileSelection();
    initNationalIdValidation();
    handleShippingAddressSave();
	characterLimitEvents();

	$('.addressname .addressid').attr('type', 'hidden'); // Avoid to autocomplete address 1

    if($('body').hasClass('checkout_page')) {
        initializeBillingSection();
        initializeShippingSection();
        initializeLoginContainer();
    }

    function initializeBillingSection() {
        const $countryButton = $('#dwfrm_billing_billingAddress_addressFields_country-button');
        $countryButton.trigger('click');
        singleShippingDesign();
        savedAddressViewShipping();
        billingSectionErrorMessage();
        checkoutHeader.init();
        stickySideBarInit();
    }

	reinsuranceCheckout.reinsuranceCartClickEvent();
	getShippingPhoneNumWithCode();
	loadReinsuranceCart();
	initializeStickySidebar();
	cart.cartPayPalExpressPopup();
	$(document).on('applePayDisplayErr', function (event, json, string) {
		// parameter is stocked in json.data here.
		cart.postAppleErr(json.dataErr);
	});


	//nationality
	$(document).on('applePayDisplayNationality', function (event, json, string) {
		// parameter is stocked in json.data here.
		cart.getApplePayDisplayNationality('applepay');
	});

	//consent pop-up
	$(document).on('applePayDisplayConsent', function (event, json, string) {
		// parameter is stocked in json.data here.
		cart.getApplePayConsentModal();
	});
	$(document).ready(function() {
		$('.sameasbilling').on('change', function() {
			updateSummary();
			stickySideBarInit();
		});
		setTimeout(function() {
			$("#applepay-container button").attr("aria-label", Resources.APPLE_PAY_LABEL);
			$("div.applepay-button").removeAttr("aria-label");
		}, 1000);
	});
	},
	updateShippingMethodList
}